const styles = {
    container: {
      position: "relative",
    },
    cardMedia: {
      height: 300,
      objectFit: "cover",
    },
    arrowBox: {
      position: "absolute",
      top: "50%",
      left: 0,
      right: 0,
      display: "flex",
      justifyContent: "space-between",
    },
    iconButton: {
      color: "white",
    },
  };
  
  export default styles;
  